(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_flexi-block-product-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const clampValue = (input) => {
      const min = parseFloat(input.min) || 1;
      const max = parseFloat(input.max) || 10;
      let value = parseFloat(input.value);

      if (Number.isNaN(value)) value = min;
      input.value = String(Math.max(min, Math.min(max, value)));
    };

    const initQuantitySteppers = (scope = document) => {
      scope.querySelectorAll('[data-flexi-quantity]').forEach((wrapper) => {
        if (wrapper.dataset.flexiQuantityBound === 'true') return;
        wrapper.dataset.flexiQuantityBound = 'true';

        const input = wrapper.querySelector('[data-flexi-quantity-input]');
        const subtract = wrapper.querySelector('[data-flexi-quantity-subtract]');
        const add = wrapper.querySelector('[data-flexi-quantity-add]');
        if (!input || !subtract || !add) return;

        const step = () => parseFloat(input.step) || 1;
        const min = () => parseFloat(input.min) || 1;
        const max = () => parseFloat(input.max) || 10;

        subtract.addEventListener('click', (event) => {
          event.preventDefault();
          const current = parseFloat(input.value) || min();
          input.value = String(Math.max(min(), current - step()));
        });

        add.addEventListener('click', (event) => {
          event.preventDefault();
          const current = parseFloat(input.value) || min();
          input.value = String(Math.min(max(), current + step()));
        });

        input.addEventListener('input', () => clampValue(input));
        input.addEventListener('blur', () => clampValue(input));
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initQuantitySteppers());
    } else {
      initQuantitySteppers();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initQuantitySteppers(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-article-slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-blaze-slider').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const desktopSlides = parseFloat(clone.dataset.blazeDesktop) || 4;
        const tabletSlides = parseFloat(clone.dataset.blazeTablet) || 2.2;
        const mobileSlides = parseFloat(clone.dataset.blazeMobile) || 1.2;
        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: desktopSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
            prevArrow: el.querySelector('.blaze-prev'),
            nextArrow: el.querySelector('.blaze-next'),
          },
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initBlazeSliders();
      }, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-blog-articles"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function shouldUseSlider() {
      return window.innerWidth <= 900;
    }

    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-columns-slider').forEach((el) => {
        if (!shouldUseSlider() || el.classList.contains('blaze-initialized')) return;

        const mobileSlides = parseFloat(el.dataset.blazeMobile) || 1.2;
        const tabletSlides = parseFloat(el.dataset.blazeTablet) || 2.2;
        const loop = el.dataset.blazeLoop === 'true';
        const draggable = el.dataset.blazeDraggable === 'true';

        new BlazeSlider(el, {
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
          },
        });

        el.classList.add('blaze-initialized');
      });
    }

    function destroyBlazeSliders(target = document) {
      target.querySelectorAll('.blaze-initialized').forEach((el) => {
        const track = el.querySelector('.blaze-track');
        if (!track) return;

        const restoredGrid = track.cloneNode(true);
        restoredGrid.className = 'flexi-columns-grid';
        el.parentNode.replaceChild(restoredGrid, el);
      });
    }

    function handleResize() {
      if (shouldUseSlider()) {
        initBlazeSliders();
      } else {
        destroyBlazeSliders();
      }
    }

    handleResize();

    document.addEventListener('shopify:section:load', function (event) {
      handleResize(event.target);
    });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleResize, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-brand-benefits"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-brand-benefits-slider').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const desktopSlides = parseFloat(clone.dataset.blazeDesktop) || 4;
        const tabletSlides = parseFloat(clone.dataset.blazeTablet) || 2.2;
        const mobileSlides = parseFloat(clone.dataset.blazeMobile) || 1.2;
        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: 20,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
          },
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-collection"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-blaze-slider').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const desktopSlides = parseFloat(clone.dataset.blazeDesktop) || 4;
        const tabletSlides = parseFloat(clone.dataset.blazeTablet) || 2.2;
        const mobileSlides = parseFloat(clone.dataset.blazeMobile) || 1.2;
        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: desktopSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
            prevArrow: el.querySelector('.blaze-prev'),
            nextArrow: el.querySelector('.blaze-next'),
          },
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initBlazeSliders();
      }, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-columns"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function shouldUseSlider() {
      return window.innerWidth <= 900;
    }

    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-columns-slider').forEach((el) => {
        if (!shouldUseSlider() || el.classList.contains('blaze-initialized')) return;

        const mobileSlides = parseFloat(el.dataset.blazeMobile) || 1.2;
        const tabletSlides = parseFloat(el.dataset.blazeTablet) || 2.2;
        const loop = el.dataset.blazeLoop === 'true';
        const draggable = el.dataset.blazeDraggable === 'true';

        new BlazeSlider(el, {
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
          },
        });

        el.classList.add('blaze-initialized');
      });
    }

    function destroyBlazeSliders(target = document) {
      target.querySelectorAll('.blaze-initialized').forEach((el) => {
        const track = el.querySelector('.blaze-track');
        if (!track) return;

        const restoredGrid = track.cloneNode(true);
        restoredGrid.className = 'flexi-columns-grid';
        el.parentNode.replaceChild(restoredGrid, el);
      });
    }

    function handleResize() {
      if (shouldUseSlider()) {
        initBlazeSliders();
      } else {
        destroyBlazeSliders();
      }
    }

    handleResize();

    document.addEventListener('shopify:section:load', function (event) {
      handleResize(event.target);
    });

  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-featured-images"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    let images = document.querySelectorAll('.flexi-featured-img, .flexi-featured-placeholder-img');
    let currentIndex = 0;

    images[0].style.display = 'block';

    function showNextImage() {
      images[currentIndex].style.display = 'none';
      images[currentIndex].classList.remove('flexi-featured-image-fade');

      currentIndex = (currentIndex + 1) % images.length;
      images[currentIndex].style.display = 'block';
      images[currentIndex].classList.add('flexi-featured-image-fade');

      let loadingBar = document.querySelector('.flexi-loading-bar');
      loadingBar.style.animation = 'none';
      loadingBar.offsetHeight;
      loadingBar.style.animation = '';
    }

    setInterval(showNextImage, 3000);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-product-columns"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function shouldUseSlider() {
      return window.innerWidth <= 900;
    }

    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-columns-slider').forEach((el) => {
        if (!shouldUseSlider() || el.classList.contains('blaze-initialized')) return;

        const mobileSlides = parseFloat(el.dataset.blazeMobile) || 1.2;
        const tabletSlides = parseFloat(el.dataset.blazeTablet) || 2.2;
        const loop = el.dataset.blazeLoop === 'true';
        const draggable = el.dataset.blazeDraggable === 'true';

        new BlazeSlider(el, {
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
          },
        });

        el.classList.add('blaze-initialized');
      });
    }

    function destroyBlazeSliders(target = document) {
      target.querySelectorAll('.blaze-initialized').forEach((el) => {
        const track = el.querySelector('.blaze-track');
        if (!track) return;

        const restoredGrid = track.cloneNode(true);
        restoredGrid.className = 'flexi-columns-grid';
        el.parentNode.replaceChild(restoredGrid, el);
      });
    }

    function handleResize() {
      if (shouldUseSlider()) {
        initBlazeSliders();
      } else {
        destroyBlazeSliders();
      }
    }

    // Initial run
    handleResize();

    // On section load (e.g., theme editor)
    document.addEventListener('shopify:section:load', function (event) {
      handleResize(event.target);
    });

    // Debounced resize handler
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleResize, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-product-repeater"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-blaze-slider').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const desktopSlides = parseFloat(clone.dataset.blazeDesktop) || 4;
        const tabletSlides = parseFloat(clone.dataset.blazeTablet) || 2.2;
        const mobileSlides = parseFloat(clone.dataset.blazeMobile) || 1.2;
        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: desktopSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
            prevArrow: el.querySelector('.blaze-prev'),
            nextArrow: el.querySelector('.blaze-next'),
          },
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initBlazeSliders();
      }, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-product-slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-blaze-slider').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const desktopSlides = parseFloat(clone.dataset.blazeDesktop) || 4;
        const tabletSlides = parseFloat(clone.dataset.blazeTablet) || 2.2;
        const mobileSlides = parseFloat(clone.dataset.blazeMobile) || 1.2;
        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: desktopSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
            prevArrow: el.querySelector('.blaze-prev'),
            nextArrow: el.querySelector('.blaze-next'),
          },
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initBlazeSliders();
      }, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();

          this.form = this.querySelector('form');
          this.variantIdInput = this.form.querySelector('[name="id"]');
          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton.querySelector('span');
          this.spinner = this.querySelector('.flexi-loading-spinner');
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.quantityInput = this.querySelector('[name="quantity"]');

          this.variantIdInput.disabled = false;

          // Add event listener for the quantity input
          if (this.quantityInput) {
            this.quantityInput.addEventListener('input', this.onQuantityChange.bind(this));
          }

          // Add event listener for the form submission
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }

        onQuantityChange(evt) {
          // Prevent form submission on quantity change
          evt.preventDefault();
          const quantity = parseInt(evt.target.value, 10) || 1;
          if (quantity < 1) {
            this.quantityInput.value = 1;
          }
        }

        onSubmitHandler(evt) {
          evt.preventDefault();
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

          this.toggleLoadingState(true);

          const formData = new FormData(this.form);
          const config = {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          };

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          fetch('/cart/add.js', config)
            .then((response) => response.json())
            .then((data) => {
              if (data.status) {
                this.handleErrorMessage(data.description || 'An error occurred.');
                this.toggleSubmitButton(true, 'Sold Out');
                return;
              }

              if (this.cart) {
                this.triggerCartNotification(data);
              } else {
                this.refreshThemeCart(data);
              }

              this.showAddedState();
            })
            .catch((err) => console.error(err))
            .finally(() => this.toggleLoadingState(false));
        }

        refreshThemeCart(itemData) {
          document.dispatchEvent(
            new CustomEvent('product-drawer:added-to-cart', { detail: itemData })
          );

          return fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
              if (window.wetheme && typeof window.wetheme.updateCartDrawer === 'function') {
                window.wetheme.updateCartDrawer(cart);
              }
            })
            .catch((err) => console.error(err));
        }

        showAddedState() {
          const atcText = this.submitButton.querySelector('.flexi-atc-text');
          if (!atcText) return;
          const original = atcText.textContent;
          atcText.textContent = 'Added';
          window.clearTimeout(this.addedStateTimer);
          this.addedStateTimer = window.setTimeout(() => {
            atcText.textContent = original;
          }, 2000);
        }

        triggerCartNotification(cartData) {
          if (this.cart.tagName.toLowerCase() === 'cart-notification') {
            this.cart.renderContents(cartData);
          } else if (this.cart.tagName.toLowerCase() === 'cart-drawer') {
            this.cart.renderContents(cartData);
            this.cart.classList.add('is-open');
          }
        }

        toggleLoadingState(isLoading) {
          if (isLoading) {
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.classList.add('loading');
            if (this.spinner) {
              this.spinner.classList.add('visible');
            }
            const atcContent = this.submitButton.querySelector('.flexi-atc-content');
            if (atcContent) {
              atcContent.classList.add('hidden');
            }
          } else {
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('loading');
            if (this.spinner) {
              this.spinner.classList.remove('visible');
            }
            const atcContent = this.submitButton.querySelector('.flexi-atc-content');
            if (atcContent) {
              atcContent.classList.remove('hidden');
            }
          }
        }

        handleErrorMessage(errorMessage = '') {
          const errorWrapper = this.querySelector('.product-form__error-message-wrapper');
          const errorElement = this.querySelector('.product-form__error-message');
          if (!errorWrapper || !errorElement) return;

          if (errorMessage) {
            errorWrapper.hidden = false;
            errorElement.textContent = errorMessage;
          } else {
            errorWrapper.hidden = true;
          }
        }

        toggleSubmitButton(disable, text) {
          if (disable) {
            this.submitButton.setAttribute('disabled', 'disabled');
            if (text) this.submitButtonText.textContent = text;
          } else {
            this.submitButton.removeAttribute('disabled');
            this.submitButtonText.textContent = 'Add to Cart';
          }
        }
      }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    const roots = document.querySelectorAll('[data-flexi-product-layout]');

    const revealPagination = (sliderEl) => {
      const el = sliderEl?.querySelector('.blaze-pagination');
      if (!el) return;
      el.classList.remove('u-opacity-0');
      el.classList.add('u-opacity-100');
    };

    const destroySlider = (sliderEl) => {
      if (!sliderEl) return;

      sliderEl._flexiScrollbarCleanup?.();
      delete sliderEl._flexiScrollbarCleanup;
      const obs = sliderEl._flexiScrollbarObserver;
      if (obs) {
        obs.disconnect();
        delete sliderEl._flexiScrollbarObserver;
      }

      const instance = sliderEl.blazeSlider;
      if (instance?.destroy) instance.destroy();

      const paginationEl = sliderEl.querySelector('.blaze-pagination');
      if (paginationEl) paginationEl.innerHTML = '';

      sliderEl.blazeSlider = null;
    };

    const setupScrollbarPagination = (sliderEl, slider) => {
      const paginationEl = sliderEl.querySelector('.blaze-pagination--scrollbar');
      if (!paginationEl || !slider) return;

      const trackEl = paginationEl.querySelector('.blaze-scrollbar-track');
      const fillEl = paginationEl.querySelector('.blaze-scrollbar-fill');
      const blazeTrack = sliderEl.querySelector('.blaze-track');
      if (!trackEl || !fillEl || !blazeTrack) return;

      let hideTimer = null;
      const showScrollbar = () => {
        paginationEl.classList.add('blaze-scrollbar-visible');
        if (hideTimer) clearTimeout(hideTimer);
        hideTimer = setTimeout(() => {
          paginationEl.classList.remove('blaze-scrollbar-visible');
          hideTimer = null;
        }, 1000);
      };

      const updateScrollbar = (percent) => {
        fillEl.style.width = Math.max(0, Math.min(100, percent)) + '%';
      };

      const updateFromState = () => {
        const numStates = slider.states?.length || 1;
        paginationEl.style.display = numStates <= 1 ? 'none' : '';
        if (numStates <= 1) return;
        const idx = slider.stateIndex ?? 0;
        updateScrollbar((idx / (numStates - 1)) * 100);
      };

      slider.onSlide(updateFromState);
      updateFromState();

      const container = sliderEl.querySelector('.blaze-container');
      if (container) {
        container.addEventListener('pointerdown', showScrollbar);
        container.addEventListener('touchstart', showScrollbar);
      }

      trackEl.addEventListener('click', (e) => {
        const rect = trackEl.getBoundingClientRect();
        const percent = ((e.clientX - rect.left) / rect.width) * 100;
        const numStates = slider.states?.length || 1;
        if (numStates <= 1) return;
        const targetIdx = Math.round((percent / 100) * (numStates - 1));
        const steps = targetIdx - (slider.stateIndex ?? 0);
        if (steps > 0) slider.next(steps);
        else if (steps < 0) slider.prev(-steps);
      });

      const obs = new MutationObserver(() => {
        showScrollbar();
        requestAnimationFrame(() => {
          const wrapper = blazeTrack.closest('.blaze-track-wrapper') || blazeTrack.parentElement;
          if (!wrapper) return;
          const wr = wrapper.getBoundingClientRect();
          const tr = blazeTrack.getBoundingClientRect();
          const maxScroll = Math.max(0, tr.width - wr.width);
          if (maxScroll <= 0) return;
          updateScrollbar((Math.max(0, Math.min(1, (wr.left - tr.left) / maxScroll))) * 100);
        });
      });
      obs.observe(blazeTrack, { attributes: true, attributeFilter: ['style'] });
      sliderEl._flexiScrollbarObserver = obs;
      sliderEl._flexiScrollbarCleanup = () => {
        if (hideTimer) clearTimeout(hideTimer);
        container?.removeEventListener('pointerdown', showScrollbar);
        container?.removeEventListener('touchstart', showScrollbar);
      };
    };

    const createSlider = (sliderEl) => {
      if (!sliderEl || sliderEl.blazeSlider) return sliderEl?.blazeSlider || null;

      const paginationStyle = sliderEl.dataset.blazePaginationStyle || 'dots';
      const slider = new BlazeSlider(sliderEl, {
        all: {
          slidesToShow: 1,
          slidesToScroll: 1,
          transitionDuration: 200,
          loop: false,
          draggable: true,
          enablePagination: paginationStyle === 'dots',
        },
        '(max-width: 1024px)': {
          slidesToShow: 1.2,
        },
      });

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          slider.refresh();
          revealPagination(sliderEl);
          if (paginationStyle === 'scrollbar') {
            setupScrollbarPagination(sliderEl, slider);
          }
        });
      });

      return slider;
    };

    const reinitRootSlider = (root) => {
      const sliderEl = root.querySelector('.flexi-product-slider');
      if (!sliderEl) return;

      destroySlider(sliderEl);
      createSlider(sliderEl);
    };

    roots.forEach((root) => {
      window.addEventListener('load', () => reinitRootSlider(root));
    });

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-flexi-product-layout]').forEach((root) => {
        reinitRootSlider(root);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-rotating-images"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-blaze-rotating-images').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: 1,
            slidesToScroll: 1,
            transitionDuration: 200,
            slideGap: '0px',
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
            prevArrow: el.querySelector('.blaze-prev'),
            nextArrow: el.querySelector('.blaze-next'),
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        initBlazeSliders();
      }, 300);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-slider"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
      target.querySelectorAll('.flexi-blaze-slider').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const desktopSlides = parseFloat(clone.dataset.blazeDesktop) || 4;
        const tabletSlides = parseFloat(clone.dataset.blazeTablet) || 2.2;
        const mobileSlides = parseFloat(clone.dataset.blazeMobile) || 1.2;
        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        new BlazeSlider(clone, {
          all: {
            slidesToShow: desktopSlides,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
            prevArrow: el.querySelector('.blaze-prev'),
            nextArrow: el.querySelector('.blaze-next'),
          },
          '(max-width: 900px)': {
            slidesToShow: tabletSlides,
          },
          '(max-width: 500px)': {
            slidesToShow: mobileSlides,
          },
        });
      });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
      initBlazeSliders(event.target);
    });

  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-slideshow"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    /** Best horizontal overlap with the viewport (non-loop and mid-transition). */
    const getDominantVisibleSlide = (sliderEl) => {
      const wrapper = sliderEl.querySelector('.blaze-track-wrapper');
      const track = sliderEl.querySelector('.blaze-track');
      if (!wrapper || !track?.children?.length) return null;
      const w = wrapper.getBoundingClientRect();
      let best = null;
      let bestOverlap = 0;
      for (const slide of track.children) {
        const r = slide.getBoundingClientRect();
        const overlap = Math.min(r.right, w.right) - Math.max(r.left, w.left);
        if (overlap > bestOverlap) {
          bestOverlap = overlap;
          best = slide;
        }
      }
      return best;
    };

    /**
     * With loop:true Blaze prepends/appends nodes so the active slide is the first child once offset is 0.
     * With loop:false the track only translates — use overlap to find the slide in the viewport.
     */
    const getSlideToMeasure = (sliderEl, slider) => {
      const track = sliderEl.querySelector('.blaze-track');
      if (!track?.children?.length) return null;
      const loop = slider && slider.config && slider.config.loop;
      const off = slider && typeof slider.offset === 'number' ? slider.offset : 0;
      if (loop && off === 0) {
        return track.firstElementChild;
      }
      return getDominantVisibleSlide(sliderEl) || track.firstElementChild;
    };

    const measureSlideNaturalHeight = (slide) => {
      if (!slide) return 0;
      return Math.ceil(Math.max(slide.offsetHeight, slide.scrollHeight || 0));
    };

    const clearSlideCaps = (sliderEl) => {
      const track = sliderEl.querySelector('.blaze-track');
      if (!track) return;
      for (const s of track.children) {
        s.style.removeProperty('max-height');
        s.style.removeProperty('overflow');
      }
    };

    const applySlideCaps = (sliderEl, h) => {
      const track = sliderEl.querySelector('.blaze-track');
      if (!track || h <= 0) return;
      for (const s of track.children) {
        s.style.maxHeight = h + 'px';
        s.style.overflow = 'hidden';
      }
    };

    /**
     * Do NOT call slider.refresh() — Blaze refresh() resets slide position (destroy+construct).
     * Flex row cross-size is max(all slides); cap every slide with max-height so the row matches
     * the dominant visible slide only.
     */
    const syncTrackHeightFromSlides = (sliderEl, slider) => {
      const layoutRoot = sliderEl.parentElement;
      if (!layoutRoot || !layoutRoot.classList.contains('flexi-layout-slider')) return;

      delete sliderEl._flexiAppliedTrackH;

      clearSlideCaps(sliderEl);
      layoutRoot.style.removeProperty('--flexi-slideshow-track-height');
      layoutRoot.classList.add('flexi-slideshow--measure');

      const finish = () => {
        const slide = getSlideToMeasure(sliderEl, slider);
        const h = measureSlideNaturalHeight(slide);
        layoutRoot.classList.remove('flexi-slideshow--measure');
        if (h > 0) {
          sliderEl._flexiAppliedTrackH = h;
          layoutRoot.style.setProperty('--flexi-slideshow-track-height', h + 'px');
          applySlideCaps(sliderEl, h);
        } else {
          delete sliderEl._flexiAppliedTrackH;
          layoutRoot.style.removeProperty('--flexi-slideshow-track-height');
          clearSlideCaps(sliderEl);
        }
      };

      requestAnimationFrame(() => {
        requestAnimationFrame(finish);
      });
    };

    const bindTrackHeightToSlides = (sliderEl, slider) => {
      const layoutRoot = sliderEl.parentElement;
      let unsubSlide = null;
      let winResize = null;
      let winTimer = null;
      let slideTimer = null;
      let transTimer = null;
      let detailsTimer = null;
      let detailsMo = null;

      const scheduleSync = () => {
        clearTimeout(slideTimer);
        slideTimer = window.setTimeout(() => {
          syncTrackHeightFromSlides(sliderEl, slider);
        }, 0);
      };

      if (typeof MutationObserver !== 'undefined') {
        detailsMo = new MutationObserver((mutations) => {
          let hit = false;
          for (let i = 0; i < mutations.length; i++) {
            const m = mutations[i];
            if (m.type !== 'attributes' || m.attributeName !== 'open') continue;
            const node = m.target;
            if (node instanceof HTMLDetailsElement && sliderEl.contains(node)) {
              hit = true;
              break;
            }
          }
          if (!hit) return;
          clearTimeout(detailsTimer);
          detailsTimer = window.setTimeout(() => {
            requestAnimationFrame(() => {
              syncTrackHeightFromSlides(sliderEl, slider);
            });
          }, 10);
        });
        detailsMo.observe(sliderEl, {
          subtree: true,
          attributes: true,
          attributeFilter: ['open'],
        });
      }

      if (slider && typeof slider.onSlide === 'function') {
        unsubSlide = slider.onSlide(() => {
          scheduleSync();
        });
      }

      const track = sliderEl.querySelector('.blaze-track');
      const onTransitionEnd = (e) => {
        if (e.target !== track || e.propertyName !== 'transform') return;
        clearTimeout(transTimer);
        transTimer = window.setTimeout(() => {
          syncTrackHeightFromSlides(sliderEl, slider);
        }, 16);
      };
      if (track) {
        track.addEventListener('transitionend', onTransitionEnd);
      }

      winResize = () => {
        clearTimeout(winTimer);
        winTimer = window.setTimeout(() => syncTrackHeightFromSlides(sliderEl, slider), 300);
      };
      window.addEventListener('resize', winResize);

      sliderEl._flexiTrackHeightCleanup = () => {
        clearTimeout(winTimer);
        clearTimeout(slideTimer);
        clearTimeout(transTimer);
        clearTimeout(detailsTimer);
        window.removeEventListener('resize', winResize);
        if (detailsMo) {
          detailsMo.disconnect();
          detailsMo = null;
        }
        if (track) {
          track.removeEventListener('transitionend', onTransitionEnd);
        }
        if (typeof unsubSlide === 'function') unsubSlide();
        layoutRoot?.classList.remove('flexi-slideshow--measure');
        layoutRoot?.style.removeProperty('--flexi-slideshow-track-height');
        clearSlideCaps(sliderEl);
        delete sliderEl._flexiAppliedTrackH;
        delete sliderEl._flexiTrackHeightCleanup;
      };
    };

    const destroySlider = (sliderEl) => {
      if (!sliderEl) return;
      sliderEl._flexiTrackHeightCleanup?.();
      clearSlideCaps(sliderEl);
      const inst = sliderEl._flexiBlaze;
      if (inst && typeof inst.destroy === 'function') inst.destroy();
      delete sliderEl._flexiBlaze;
    };

    const initBlazeSliders = (target = document) => {
      target.querySelectorAll('.flexi-blaze-slideshow').forEach((el) => {
        const parent = el.parentNode;
        const clone = el.cloneNode(true);
        parent.replaceChild(clone, el);

        const loop = clone.dataset.blazeLoop === 'true';
        const draggable = clone.dataset.blazeDraggable === 'true';
        const autoplay = clone.dataset.blazeAutoplay === 'true';
        const autoplayDuration = parseFloat(clone.dataset.blazeAutoplayDuration) || 2000;
        const autoplayPause = clone.dataset.blazeAutoplayPause === 'true';

        const slider = new BlazeSlider(clone, {
          all: {
            slidesToShow: 1,
            slidesToScroll: 1,
            transitionDuration: 200,
            loop: loop,
            draggable: draggable,
            autoplayInterval: autoplayDuration,
            enableAutoplay: autoplay,
            stopAutoplayOnInteraction: autoplayPause,
            enablePagination: false,
            prevArrow: clone.querySelector('.blaze-prev'),
            nextArrow: clone.querySelector('.blaze-next'),
          },
        });

        clone._flexiBlaze = slider;
        bindTrackHeightToSlides(clone, slider);

        requestAnimationFrame(() => {
          requestAnimationFrame(() => syncTrackHeightFromSlides(clone, slider));
        });

        const runLoadSync = () => syncTrackHeightFromSlides(clone, slider);
        if (document.readyState === 'complete') {
          queueMicrotask(runLoadSync);
        } else {
          window.addEventListener('load', runLoadSync, { once: true });
        }
      });
    };

    initBlazeSliders();

    document.addEventListener('shopify:section:load', (event) => {
      initBlazeSliders(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.flexi-blaze-slideshow').forEach(destroySlider);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_flexi-layout-why-us"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const roots = document.querySelectorAll('[data-flexi-why-us-grid]');

    const getBreakpoint = () => {
      const w = window.innerWidth;
      if (w <= 500) return 'mobile';
      if (w <= 900) return 'tablet';
      return 'desktop';
    };

    const revealPagination = (sliderEl) => {
      const el = sliderEl?.querySelector('.blaze-pagination');
      if (!el) return;
      el.classList.remove('u-opacity-0');
      el.classList.add('u-opacity-100');
    };

    const syncCardHeights = (root) => {
      root.style.removeProperty('--flexi-why-us-card-min-height');
      const cards = root.querySelectorAll('.flexi-group-icon-with-text');
      if (!cards.length) return;
      const max = Math.max(...[...cards].map((c) => c.offsetHeight));
      if (max > 0) root.style.setProperty('--flexi-why-us-card-min-height', max + 'px');
    };

    const getConfig = (sliderEl) => {
      const desktopSlides = parseFloat(sliderEl.dataset.blazeDesktop) || 4;
      const tabletSlides = parseFloat(sliderEl.dataset.blazeTablet) || 2.2;
      const mobileSlides = parseFloat(sliderEl.dataset.blazeMobile) || 1.2;
      const loop = sliderEl.dataset.blazeLoop === 'true';
      const draggable = sliderEl.dataset.blazeDraggable === 'true';
      const autoplay = sliderEl.dataset.blazeAutoplay === 'true';
      const autoplayDuration = parseFloat(sliderEl.dataset.blazeAutoplayDuration) || 2000;
      const autoplayPause = sliderEl.dataset.blazeAutoplayPause === 'true';
      const paginationStyle = sliderEl.dataset.blazePaginationStyle || 'dots';

      return {
        all: {
          slidesToShow: desktopSlides,
          slidesToScroll: 1,
          transitionDuration: 200,
          loop,
          draggable,
          autoplayInterval: autoplayDuration,
          enableAutoplay: autoplay,
          stopAutoplayOnInteraction: autoplayPause,
          enablePagination: paginationStyle === 'dots',
        },
        '(max-width: 900px)': {
          slidesToShow: tabletSlides,
        },
        '(max-width: 500px)': {
          slidesToShow: mobileSlides,
        },
      };
    };

    const destroySlider = (sliderEl) => {
      if (!sliderEl) return;

      sliderEl._flexiScrollbarCleanup?.();
      delete sliderEl._flexiScrollbarCleanup;
      const obs = sliderEl._flexiScrollbarObserver;
      if (obs) {
        obs.disconnect();
        delete sliderEl._flexiScrollbarObserver;
      }

      const instance = sliderEl._flexiBlaze;
      if (instance?.destroy) instance.destroy();
      delete sliderEl._flexiBlaze;

      const paginationEl = sliderEl.querySelector('.blaze-pagination');
      if (paginationEl) paginationEl.innerHTML = '';
    };

    const setupScrollbarPagination = (sliderEl, slider) => {
      const paginationEl = sliderEl.querySelector('.blaze-pagination--scrollbar');
      if (!paginationEl || !slider) return;

      const trackEl = paginationEl.querySelector('.blaze-scrollbar-track');
      const fillEl = paginationEl.querySelector('.blaze-scrollbar-fill');
      const blazeTrack = sliderEl.querySelector('.blaze-track');
      if (!trackEl || !fillEl || !blazeTrack) return;

      let hideTimer = null;
      const showScrollbar = () => {
        paginationEl.classList.add('blaze-scrollbar-visible');
        if (hideTimer) clearTimeout(hideTimer);
        hideTimer = setTimeout(() => {
          paginationEl.classList.remove('blaze-scrollbar-visible');
          hideTimer = null;
        }, 1000);
      };

      const updateScrollbar = (percent) => {
        fillEl.style.width = Math.max(0, Math.min(100, percent)) + '%';
      };

      const updateFromState = () => {
        const numStates = slider.states?.length || 1;
        paginationEl.style.display = numStates <= 1 ? 'none' : '';
        if (numStates <= 1) return;
        const idx = slider.stateIndex ?? 0;
        updateScrollbar((idx / (numStates - 1)) * 100);
      };

      slider.onSlide(updateFromState);
      updateFromState();

      const container = sliderEl.querySelector('.blaze-container');
      if (container) {
        container.addEventListener('pointerdown', showScrollbar);
        container.addEventListener('touchstart', showScrollbar);
      }

      trackEl.addEventListener('click', (e) => {
        const rect = trackEl.getBoundingClientRect();
        const percent = ((e.clientX - rect.left) / rect.width) * 100;
        const numStates = slider.states?.length || 1;
        if (numStates <= 1) return;
        const targetIdx = Math.round((percent / 100) * (numStates - 1));
        const steps = targetIdx - (slider.stateIndex ?? 0);
        if (steps > 0) slider.next(steps);
        else if (steps < 0) slider.prev(-steps);
      });

      const obs = new MutationObserver(() => {
        showScrollbar();
        requestAnimationFrame(() => {
          const wrapper = blazeTrack.closest('.blaze-track-wrapper') || blazeTrack.parentElement;
          if (!wrapper) return;
          const wr = wrapper.getBoundingClientRect();
          const tr = blazeTrack.getBoundingClientRect();
          const maxScroll = Math.max(0, tr.width - wr.width);
          if (maxScroll <= 0) return;
          updateScrollbar((Math.max(0, Math.min(1, (wr.left - tr.left) / maxScroll))) * 100);
        });
      });
      obs.observe(blazeTrack, { attributes: true, attributeFilter: ['style'] });
      sliderEl._flexiScrollbarObserver = obs;
      sliderEl._flexiScrollbarCleanup = () => {
        if (hideTimer) clearTimeout(hideTimer);
        container?.removeEventListener('pointerdown', showScrollbar);
        container?.removeEventListener('touchstart', showScrollbar);
      };
    };

    const createSlider = (sliderEl) => {
      if (!sliderEl || sliderEl._flexiBlaze) return sliderEl._flexiBlaze || null;

      const slider = new BlazeSlider(sliderEl, getConfig(sliderEl));
      sliderEl._flexiBlaze = slider;
      const paginationStyle = sliderEl.dataset.blazePaginationStyle || 'dots';

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          slider.refresh();
          revealPagination(sliderEl);
          if (paginationStyle === 'scrollbar') {
            setupScrollbarPagination(sliderEl, slider);
          }
          const root = sliderEl.closest('[data-flexi-why-us-grid]');
          if (root) syncCardHeights(root);
        });
      });

      return slider;
    };

    const reinitRootSlider = (root) => {
      const sliderEl = root.querySelector('.blaze-slider');
      if (sliderEl) {
        destroySlider(sliderEl);
        if (getBreakpoint() !== 'desktop') {
          createSlider(sliderEl);
        } else {
          requestAnimationFrame(() => syncCardHeights(root));
        }
      } else {
        requestAnimationFrame(() => syncCardHeights(root));
      }
    };

    roots.forEach((root) => {
      let currentBp = getBreakpoint();

      let _syncTimer = null;
      new ResizeObserver(() => {
        clearTimeout(_syncTimer);
        _syncTimer = setTimeout(() => syncCardHeights(root), 200);
      }).observe(root);

      window.addEventListener('load', () => {
        reinitRootSlider(root);
      });

      window.addEventListener('resize', () => {
        clearTimeout(root._flexiResizeTimer);
        root._flexiResizeTimer = setTimeout(() => {
          const newBp = getBreakpoint();
          if (newBp !== currentBp) {
            currentBp = newBp;
            reinitRootSlider(root);
          } else if (newBp !== 'desktop') {
            const sliderEl = root.querySelector('.blaze-slider');
            const blaze = sliderEl?._flexiBlaze ?? sliderEl?.blazeSlider;
            blaze?.refresh();
            requestAnimationFrame(() => syncCardHeights(root));
          } else {
            requestAnimationFrame(() => syncCardHeights(root));
          }
        }, 150);
      });
    });

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-flexi-why-us-grid]').forEach((root) => {
        reinitRootSlider(root);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["flexi-block-accordion"] && !Shopify.designMode) return;
  try {
    (() => {
    const initAccordions = (scope = document) => {
      scope.querySelectorAll('.flexi-accordion-block').forEach((root) => {
        root.querySelectorAll('[data-flexi-accordion-item]').forEach((item) => {
          const trigger = item.querySelector('[data-flexi-accordion-trigger]');
          const panel = item.querySelector('[data-flexi-accordion-panel]');
          const icon = trigger ? trigger.querySelector('.flexi-rotate-icon') : null;

          if (!trigger || !panel || trigger.dataset.flexiAccordionBound === 'true') return;
          trigger.dataset.flexiAccordionBound = 'true';

          trigger.addEventListener('click', () => {
            const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
            const nextExpanded = !isExpanded;

            trigger.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
            panel.classList.toggle('is-open', nextExpanded);
            panel.setAttribute('aria-hidden', nextExpanded ? 'false' : 'true');

            if (icon) {
              icon.classList.toggle('flexi-rotate-icon--active', nextExpanded);
            }
          });
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAccordions());
    } else {
      initAccordions();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAccordions(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["flexi-block-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    let openOverlay = null;
    let lastTrigger = null;

    const lockScroll = () => {
      document.body.style.overflow = 'hidden';
    };

    const unlockScroll = () => {
      if (!document.querySelector('.flexi-popup-overlay.is-open')) {
        document.body.style.overflow = '';
      }
    };

    const closeOverlay = (overlay) => {
      if (!overlay) return;

      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');

      if (openOverlay === overlay) {
        openOverlay = null;
      }

      unlockScroll();

      if (lastTrigger) {
        lastTrigger.focus();
        lastTrigger = null;
      }
    };

    const openOverlayEl = (overlay, trigger) => {
      if (!overlay) return;

      if (openOverlay && openOverlay !== overlay) {
        closeOverlay(openOverlay);
      }

      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      openOverlay = overlay;
      lastTrigger = trigger || null;
      lockScroll();

      const closeBtn = overlay.querySelector('[data-flexi-popup-close]');
      if (closeBtn) closeBtn.focus();
    };

    const removeOverlayByTrigger = (root) => {
      const trigger = root.querySelector('[data-flexi-popup-open]');
      const overlayId = trigger?.getAttribute('aria-controls');
      if (!overlayId) return;

      const overlay = document.getElementById(overlayId);
      if (!overlay) return;

      if (openOverlay === overlay) closeOverlay(overlay);
      overlay.remove();
    };

    const initPopups = (scope = document) => {
      scope.querySelectorAll('[data-flexi-popup]').forEach((root) => {
        if (root.dataset.flexiPopupBound === 'true') return;

        const trigger = root.querySelector('[data-flexi-popup-open]');
        const overlay = root.querySelector('[data-flexi-popup-overlay]');
        if (!trigger || !overlay) return;

        root.dataset.flexiPopupBound = 'true';

        const existing = document.getElementById(overlay.id);
        if (existing && existing !== overlay) {
          if (openOverlay === existing) closeOverlay(existing);
          existing.remove();
        }

        if (overlay.parentElement !== document.body) {
          document.body.appendChild(overlay);
        }

        trigger.addEventListener('click', () => {
          openOverlayEl(overlay, trigger);
        });

        overlay.addEventListener('click', (event) => {
          if (event.target === overlay) {
            closeOverlay(overlay);
          }
        });

        overlay.querySelectorAll('[data-flexi-popup-close]').forEach((btn) => {
          btn.addEventListener('click', () => closeOverlay(overlay));
        });
      });
    };

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && openOverlay) {
        closeOverlay(openOverlay);
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initPopups());
    } else {
      initPopups();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initPopups(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-flexi-popup]').forEach(removeOverlayByTrigger);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["flexi-block-tabs"] && !Shopify.designMode) return;
  try {
    (() => {
    const selectTab = (root, nextTab) => {
      const tabs = [...root.querySelectorAll('[data-flexi-tab]')];
      const panels = [...root.querySelectorAll('[data-flexi-tabpanel]')];

      tabs.forEach((tab) => {
        const isSelected = tab.dataset.flexiTab === nextTab;
        tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
        tab.classList.toggle('active', isSelected);
        tab.classList.toggle('not-active', !isSelected);
        if (isSelected) tab.focus();
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.flexiTabpanel !== nextTab;
      });
    };

    const initTabs = (scope = document) => {
      scope.querySelectorAll('[data-flexi-tabs]').forEach((root) => {
        if (root.dataset.flexiTabsBound === 'true') return;
        root.dataset.flexiTabsBound = 'true';

        const tablist = root.querySelector('[data-flexi-tablist]');
        const tabs = [...root.querySelectorAll('[data-flexi-tab]')];
        if (!tablist || !tabs.length) return;

        tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            selectTab(root, tab.dataset.flexiTab);
          });
        });

        tablist.addEventListener('keydown', (event) => {
          const currentIndex = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
          if (currentIndex < 0) return;

          let nextIndex = currentIndex;
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            nextIndex = (currentIndex + 1) % tabs.length;
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
          } else {
            return;
          }

          selectTab(root, tabs[nextIndex].dataset.flexiTab);
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initTabs());
    } else {
      initTabs();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initTabs(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
